module.exports = __webpack_public_path__ + "img/bigright2.e9377304.svg";